import React,{useEffect} from 'react'
import {Card, CardHeader, CardFooter, CardBody, Text,Box,Form,FormField,TextInput,Layer,Button} from 'grommet'
import {ContactInfo,Organization,FormClose,Mail,Phone,Edit, Location,StatusCritical, Save,Checkmark} from 'grommet-icons';
import CountriesDropdown from './countryDropdown';
import { withRouter } from 'react-router-dom';
import {LoadLayer, PostalCodeRequired} from './utils/shared/shared'
import {FindLocation,SaveToAddressBook} from './utils/shared/requests'
import _ from 'lodash'

function EditAddressLayer(props){
    const [lab, setLab] = React.useState(props.shipmentLocation)
    const [show, setShow] = React.useState();
    const [locationErr, setLocationErr] = React.useState()
    const [geoCodeShow, setGeoCodeShow] = React.useState();
    const [country, setCountry] = React.useState()
    const [formValid, setFormValid] = React.useState(true)
    const postCodeRequired = PostalCodeRequired(lab.country.CountryCode)
      useEffect( () => {
        if (lab.name !== props.shipmentLocation.name){
          setLab(props.shipmentLocation) 
        }
        
      }, [props.shipmentLocation, country])

    const reloadLab = () => {
      setShow(false)
      setLab(props.shipmentLocation)
      setCountry(props.shipmentLocation.country)
    }

    function setAddress(lab, type){
      if (lab.city.length <= 0 ){
        return
      } else {
        setShow(false)
        props.setLocation(lab, type)
      }
    }

    function layerControl(validation, postCodeRequired){
      console.log(validation)
      if (validation.valid){
        setFormValid(true)
      } else if (postCodeRequired === false || JSON.stringify(validation.errors) === "{}"){
        setFormValid(true)
      } else {
        setFormValid(false)
      }
    }
    return (
        <Box>
            <Button primary margin='small' size='small' icon={<Edit />} label={<Text weight={'bold'} size='small'>Edit Address</Text>} onClick={() => setShow(true)}/>
        {show && (
          <Layer
            onEsc={() => reloadLab()}
            onClickOutside={() => reloadLab()}
          >
            <Card pad='small'>
            <CardHeader pad='small'>
                <Button size='xsmall' hoverIndicator icon={<FormClose color='brand' />} onClick={() => reloadLab()} />
                <Text alignSelf='center' size='large' weight='bold'>{props.shipmentLocation.name}</Text>
                <Organization color='brand' />
                </CardHeader>
            <CardBody>
              <Box>
                <Box width={'small'}>
                 <Button icon={<Location />} primary size='small' hoverIndicator width='small' label={'Find My Location'} onClick={() => {FindLocation(lab, setLab, geoCodeShow, setGeoCodeShow, setCountry,setLocationErr)}} />
                 {locationErr && (
                  <Layer position="bottom" modal={false} margin={{ vertical: 'medium', horizontal: 'small' }}  responsive={false} plain>
                  <Box align="center" direction="row" gap="small" justify="between" round="medium" elevation="large" pad={{ vertical: 'xsmall', horizontal: 'small' }} background="status-critical">
                      <Box align="center" direction="row" gap="xsmall">
                      <StatusCritical color='light-1'/>
                      <Text color='light-1' background='light-1'>
                        Location Not Found
                      </Text>
                      </Box>
                      <Button icon={<FormClose color='light-1'/>} plain />
                      </Box>
                  </Layer>
                  )}
                </Box>
                {geoCodeShow && (
                  <LoadLayer load={geoCodeShow} label={"Finding Location..."} />
                )}
            <Form value={lab} onChange={(nextValue) => setLab(nextValue)} validate='change' onValidate={(validationResults) => {console.log('called'); layerControl(validationResults, postCodeRequired)}}>
            <Box direction='row'>
              <FormField validate={{regexp:/^[\sA-Za-z().,;:0-9_-]{1,34}$/i, message: <Text size='small' color='status-critical'>Field must be more than 1 and less than 34 characters.</Text>}}  borderSize='xsmall' width='medium' label={<Text size='xsmall'>Company Name</Text>} name='name' margin='small' >
                  <TextInput size='xsmall' icon={<Organization />} name='name' placeholder="Company Name" />
              </FormField>
              <FormField info={<Text  color='text-xweak' size='xsmall'>Optional</Text>} label={<Text size='xsmall'>EORI Number</Text>} name='eori_number' margin='small' >
                    <TextInput size='xsmall' icon={<Organization />} name='eori_number' placeholder="Enter Company EORI Number" />
                </FormField>
                <FormField info={<Text  color='text-xweak' size='xsmall'>Optional</Text>} label={<Text size='xsmall'>VAT Number</Text>} name='vat_number' margin='small' >
                    <TextInput size='xsmall' icon={<Organization/>} name='vat_number' placeholder="Enter Company VAT Number" />
                </FormField>
                <FormField info={<Text  color='text-xweak' size='xsmall'>Optional</Text>} label={<Text size='xsmall'>Tax ID Number</Text>} name='tax_id' margin='small' >
                    <TextInput size='xsmall' icon={<Organization/>} name='tax_id' placeholder="Enter Tax ID Number" />
                </FormField>
              </Box>
              <Box direction='row'>
              <FormField validate={{regexp:/^[\sA-Za-z.,;:0-9_-]{1,45}$/i, message: <Text size='small' color='status-critical'>Field must be more than 1 and less than 44 characters.</Text>}} required borderSize='xsmall' label={<Text size='xsmall'>Contact Person</Text>} name='primary_contact_person' margin='small' >
                  <TextInput size='xsmall' icon={<ContactInfo />} name='primary_contact_person' placeholder="Primary Contact Name" />
              </FormField>
              <FormField validate={{regexp:/^[\sA-Z+@.,;:0-9_-]{1,50}$/i, message: <Text size='small' color='status-critical'>Field must be more than 1 and less than 50 characters.</Text>}} required width='medium' label={<Text size='xsmall'>Contact Email</Text>} name='primary_contact_email' margin='small' >
                  <TextInput size='xsmall' icon={<Mail/>} name='primary_contact_email' placeholder="Enter Primary Contact Email" />
              </FormField>
              <FormField validate={{regexp:/^[\s/A-Z+a-z().,;:0-9_-]{1,25}$/i, message: <Text size='small' color='status-critical'>Field must be more than 1 and less than 25 characters.</Text>}} required label={<Text size='xsmall'>Contact Number</Text>} name='primary_contact_phone' margin='small' >
                  <TextInput size='xsmall' icon={<Phone />}name='primary_contact_phone' placeholder="Enter Primary Contact Number" />
              </FormField>
              </Box>
              <Box direction='row' border='top'>
              <FormField validate={{regexp:/^[\s/A-Z+a-z/().,:;0-9_-]{1,44}$/i, message: <Text size='small' color='status-critical'>Field must be less than 44 characters.</Text>}}  width='medium' borderSize='xsmall' label={<Text size='xsmall'>Address Line One</Text>} name='address_line_one' margin='small' >
                  <TextInput size='xsmall' icon={<ContactInfo />} name='address_line_one' placeholder="Address Line One" />
              </FormField>
              <FormField validate={{regexp:/^[\s/A-Z+a-z/().,;:0-9_-]{0,44}$/i, message: <Text size='small' color='status-critical'>Field must be less than 44 characters.</Text>}} width='medium' borderSize='xsmall' label={<Text size='xsmall'>Address Line Two</Text>} name='address_line_two' margin='small' >
                  <TextInput size='xsmall' icon={<ContactInfo />} name='address_line_two' placeholder="Address Line Two" />
              </FormField>
              </Box>
              <Box direction='row'>
              <FormField validate={{regexp:/^[\s/A-Z+a-z/().,;:0-9_-]{0,44}$/i, message: <Text size='small' color='status-critical'>Field must be less than 44 characters.</Text>}}  width='medium' borderSize='xsmall' label={<Text size='xsmall'>Address Line Three</Text>} name='address_line_three' margin='small' >
                  <TextInput size='xsmall' icon={<ContactInfo />} name='address_line_three' placeholder="Address Line Three" />
              </FormField>
              <FormField required width='medium'borderSize='xsmall' label={<Text size='xsmall'>City</Text>} name='city' margin='small' >
                  <TextInput size='xsmall' icon={<ContactInfo />} name='city' placeholder="City" />
              </FormField>
              </Box>
              <Box direction='row'>
              {(postCodeRequired && 
                 <FormField validate={{regexp:/^[^\s]+(?:$|.*[^\s]+$)/, message: 'Please enter a valid Postal/Zip Code'}} required borderSize='xsmall' label={<Text size='xsmall'>Postal/Zip Code</Text>} name='postcode' margin='small' >
                   <TextInput size='xsmall' icon={<ContactInfo />} name='postcode' placeholder="Post Code" />
                  </FormField>
                 )}
              <FormField info={<Text size='xsmall' color='text-weak'>If Applicable</Text>} borderSize='xsmall' label={<Text size='xsmall'>State/County</Text>} name='county' margin='small' >
                  <TextInput size='xsmall' icon={<ContactInfo />} name='county' placeholder="State/County" />
              </FormField>
              <CountriesDropdown country={lab.country} layer={true} size='xsmall'/>
              </Box>
            </Form>
            </Box>
            </CardBody>
            <CardFooter direction='row'>
              {(formValid ?
                (props.addressType === 'origin') ?  <Button  icon={<Checkmark />} hoverIndicator primary size='small' margin='small' label="Done" onClick={() => {setAddress(lab, 'origin')}} /> :  <Button  icon={<Checkmark />} hoverIndicator primary size='small' margin='small' label="Done" onClick={() => {setAddress(lab, 'destination')}} /> 
                :
                (props.addressType === 'origin') ?  <Button icon={<Checkmark />}  hoverIndicator primary size='small' margin='small' label="Done" /> :  <Button  icon={<Checkmark />}  hoverIndicator primary size='small' margin='small' label="Done"  /> 
              )}
              {/* {(_.isEqual(props.shipmentLocation, lab) ? null: <Button onClick={() => {SaveToAddressBook(lab)}} hoverIndicator primary size='small' margin='small' icon={<Save />} label='Save to Address Book' />)} */}
            </CardFooter>
            </Card>
          </Layer>
        )}
      </Box>
    )
}

export default withRouter(EditAddressLayer)
